import {nthArg, transform, some, groupBy, createSelector} from 'helpers';

export const unprocessedChanges = createSelector(
  state => state.server.changes,
  changes => changes.filter(change => !change.processed),
);

export const changes = createSelector(
  unprocessedChanges,
  changes => transform(changes, (changes, { action, payload, type }) => {
    if (/create|update/.test(action)) {
      changes[type + payload.serverId] = true;
    }
  }, {})
);

const updating = createSelector(
  unprocessedChanges,
  changes => some(changes, ({ attempts }) => attempts < 4),
);

export const server = createSelector(
  [ state => state.server, updating ],
  ( server, updating ) => ({ ...server, updating }),
);

export const changesByType = createSelector(
  unprocessedChanges,
  changes => groupBy(changes, ({ action, type }) => action + '_' + type),
);

export const hasUnprocessedChanges = createSelector(
  unprocessedChanges,
  changes => changes.length > 0,
);

export const saved = createSelector(
  [ changes, nthArg(1) ],
  ( changes, { id, context }) => !changes[context + id],
);
